import { Icon, TextLink } from "@dgs/core";
import { FC } from "react";
import { useParams } from "react-router";
import styled from "styled-components";
import { ApplicationDetailResource, ApplicationType, EventDetailResource } from "../../shared/types";

const Header = styled.div`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(2)};
`;

const Arrow = styled(Icon)`
	width: 24px;
	height: 24px;
`;

const ApplicationName = styled.span`
	font-size: ${({ theme }) => theme.fonts.sizes.large};
`;

export const EventApplicationUsersHeader: FC<{ event: EventDetailResource }> = ({ event }) => {
	const { applicationId = "" } = useParams<"applicationId">();

	const application: ApplicationDetailResource | undefined = event.applications.find(
		(a) => String(a.id) === applicationId,
	);

	if (!application) {
		return null;
	}

	const heading = (() => {
		switch (application.type) {
			case ApplicationType.PARTICIPANT_MANAGEMENT:
				return "Participant Management";
			case ApplicationType.KRONOS:
				return "KRONOS";
			case ApplicationType.DEEP:
				if (application.configuration.enableFrontend && !application.configuration.enableApp) {
					return "DEEP";
				}
				if (!application.configuration.enableFrontend && application.configuration.enableApp) {
					return "APP";
				}

				return "DEEP & APP";
		}
	})();

	return (
		<Header>
			<TextLink to={".."}>
				<Arrow $icon="caret_left" />
			</TextLink>
			<ApplicationName>{`${heading} - ${application.projectNumber}`}</ApplicationName>
		</Header>
	);
};
